import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const $components = document.getElementsByClassName('STRIMM_PLAYER_ROOT');

for (let i = 0; i < $components.length; i++) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    $components[i]
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
